import { ECardType } from '__generated__/globalTypes';
import { CreateGuideStoryVariables } from 'graphql/mutation/__generated__/CreateGuideStory';
import { GuideQuery_guide_stories } from 'graphql/query/__generated__/GuideQuery';
import { uniq } from 'lodash';

const importKeyColumn = `Name`;

const CATEGORIES = {
    // // Employment type
    // 'Brigádu při studiu': '',
    // 'Brigádu přes prázdniny': '',
    // 'Částečný úvazek': '',
    // 'Plný pracovní uvázek': '',
    // 'Praxe/Stáž': '',
    // 'Trainee program': '',
    // 'Diplomová nebo bakalářská práce': '',
    // 'Stipendijní program': '',
    // 'Informace a poradenství ohledně získání zkušeností v zahraničí.': '',
    // 'Plný pracovní úvazek': '',
    // 'služební poměr vojáka z povolání': '',
    // 'Praxe/Stáže': '',
    // Company type
    Stavebnictví: '46f0f9b6-98a4-4513-9d23-1eb49daecb96',
    Strojní: 'd15a0405-e388-44ff-bf8b-cd8773424662',
    Elektro: '8564123e-dc1d-460a-bb02-92a24e37d0a0',
    Informatika: 'e5cf1c6f-bd01-4218-92be-571bd018e5a6',
    Ekonomie: '52d660e9-3c4c-48bb-9452-b90340844e50',
    Ostatní: '201d1feb-4811-486c-8006-62ebb9e2bd05',
    Architektura: 'e61f6236-810f-4f16-9bd0-49107e5e1134',
    Chemie: '0e97238b-10bc-49fe-a8e7-a514a8cffef2',
    Design: 'dd44cd8a-6978-4d9a-b7eb-2fd4bfff2f79',
    Stavební: 'bd06da63-7ffc-4fc7-a289-4051c3e303d4'
};

function parser(guideId: string, row: Record<string, string>): CreateGuideStoryVariables {
    const imageFormValue = row[`Logo`];

    function getLogoId() {
        if (imageFormValue?.trim().startsWith('https://drive.google.com/open?id=')) {
            return imageFormValue
                .trim()
                .replace('https://drive.google.com/open?id=', '')
                .replace('&usp=drive_copy', '');
        }
        if (imageFormValue?.trim().startsWith('https://drive.google.com/file/d/')) {
            return imageFormValue
                .trim()
                .replace('https://drive.google.com/file/d/', '')
                .replace('/view?usp=drive_link', '');
        }

        return null;
    }

    const imageId = getLogoId();

    const imageUrl = imageId ? 'https://drive.google.com/uc?id=' + imageId : null;

    const mutationPayload: CreateGuideStoryVariables = {
        guideId,
        story: {
            importKey: row[importKeyColumn],
            header: {
                title: row[`Name`],
                text: row[`Description`],
                imageUrl
            }
        },
        cards: []
    };

    if (row['Web'] || row['LinkedIn'] || row['Facebook'] || row['Instagram']) {
        mutationPayload.cards.push({
            type: ECardType.LINK,
            links: [
                {
                    title: 'Web',
                    url: row['Web']
                },
                {
                    title: 'LinkedIn',
                    url: row['LinkedIn']
                },
                {
                    title: 'Facebook',
                    url: row['Facebook']
                },
                {
                    title: 'Instagram',
                    url: row['Instagram']
                }
            ].filter((e) => e.url?.trim())
        });
    }

    if (row['Employment type']) {
        mutationPayload.cards.push({
            type: ECardType.TEXT,
            info: {
                title: 'Pracovní úvazek',
                description: row['Employment type']
            }
        });
    }

    if (row['Looking for']) {
        mutationPayload.cards.push({
            type: ECardType.TEXT,
            info: {
                title: 'Pracovní pozice',
                description: row['Looking for']
            }
        });
    }

    const categories = row['Company type']
        .replaceAll('\n', ',')
        .split(',')
        .map((e) => e.trim())
        .map((e) => CATEGORIES[e])
        .filter(Boolean);
    mutationPayload.addToCategoriesId = uniq(categories);

    return mutationPayload;
}

function duplicateChecker(story: GuideQuery_guide_stories, row: Record<string, string>): boolean {
    return story.importKey?.toLowerCase() === row[importKeyColumn]?.toLowerCase();
}

export const iaeste2024ImportMethods = { duplicateChecker, parser, importKeyColumn };
